import { CustomerServiceOutlined, PaperClipOutlined } from '@ant-design/icons';
import { Avatar as AntdAvatar, Button, Typography } from 'antd';
import cn from 'classnames';

import { Avatar } from '@app/components/Avatar';

import type {
  SupportChatMessageFileViewModel,
  SupportChatMessageViewModel,
} from '@features/SupportChat/types';
import type { FC } from 'react';

const { Text } = Typography;

const AVATAR_SIZE = 28;

interface SupportChatMessageProps {
  message: SupportChatMessageViewModel;
  downloadingFileId: number | null;
  onDownloadFile: (file: SupportChatMessageFileViewModel) => void;
}

export const SupportChatMessage: FC<SupportChatMessageProps> = ({
  message: {
    text,
    time,
    isOwn,
    senderName,
    nameFirst,
    nameLast,
    avatar,
    files,
  },
  downloadingFileId,
  onDownloadFile,
}) => {
  // Без фото и имени (сотрудник поддержки не заполнен) инициалы не из чего
  // собрать — показываем иконку поддержки.
  const hasPersonalAvatar = Boolean(avatar || nameFirst || nameLast);

  return (
    <div
      className={cn('SupportChatMessage', {
        'SupportChatMessage--own': isOwn,
      })}
    >
      {hasPersonalAvatar ? (
        <Avatar
          className="SupportChatMessage__avatar"
          size={AVATAR_SIZE}
          src={avatar}
          nameFirst={nameFirst}
          nameLast={nameLast}
        />
      ) : (
        <AntdAvatar
          className="SupportChatMessage__avatar"
          size={AVATAR_SIZE}
          icon={<CustomerServiceOutlined />}
        />
      )}
      <div className="SupportChatMessage__bubble">
        <Text className="SupportChatMessage__sender">{senderName}</Text>
        {text && <Text className="SupportChatMessage__text">{text}</Text>}
        {files.length > 0 && (
          <div className="SupportChatMessage__files">
            {files.map((file) => (
              <Button
                key={file.id}
                className="SupportChatMessage__file"
                type="link"
                size="small"
                icon={<PaperClipOutlined />}
                loading={downloadingFileId === file.id}
                title={`Скачать ${file.name}`}
                onClick={() => onDownloadFile(file)}
              >
                <span className="SupportChatMessage__file-name">
                  {file.name}
                </span>
                {file.size && (
                  <span className="SupportChatMessage__file-size">
                    {file.size}
                  </span>
                )}
              </Button>
            ))}
          </div>
        )}
        <Text type="secondary" className="SupportChatMessage__time">
          {time}
        </Text>
      </div>
    </div>
  );
};
